import { useCallback } from "react";

let useGoogleReCaptcha;
try {
  useGoogleReCaptcha = require("react-google-recaptcha-v3").useGoogleReCaptcha;
} catch {
  useGoogleReCaptcha = () => ({ executeRecaptcha: null });
}

export function useRecaptcha() {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getToken = useCallback(async (action = "submit") => {
    if (!executeRecaptcha) return "";
    try {
      return await executeRecaptcha(action);
    } catch {
      return "";
    }
  }, [executeRecaptcha]);

  return { getToken };
}
